import Loading from "@/components/loading/loading";
import { DisposeBag } from "@/utils/manager/dispose-bag";
import { InitializationStateManager } from "@/utils/manager/initialization-state-manager";
import { useEffect, useState } from "react";
import "@/utils/i18n/client";

interface InitializationStateComponentProps {
  children: React.ReactNode;
}

export const InitializationStateComponent = (props: InitializationStateComponentProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const disposeBag = new DisposeBag();
  const initializationStateManager = InitializationStateManager.getInstance();
  initializationStateManager.startInitialization();

  useEffect(() => {
    initializationStateManager.isCompletedInitialization
      .subscribe((isCompleted) => {
        console.log("[InitializationStateComponent] :: isCompletedInitialization", isCompleted);
        console.log("[InitializationStateComponent] :: i18n ready 초기화 완료");
        setIsLoading(!isCompleted);
      })
      .disposed(disposeBag);

    return () => {
      disposeBag.dispose();
    };
  }, []);

  // 조건부 렌더링 대신 항상 같은 구조를 유지
  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && props.children}
    </>
  );
};
